class HeroCarousel {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(root.querySelectorAll('.hero-carousel__dot'));
    this.prevBtn = root.querySelector('.hero-carousel__arrow--prev');
    this.nextBtn = root.querySelector('.hero-carousel__arrow--next');

    this.current = 0;
    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = parseInt(root.dataset.speed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    this.playActiveVideo();
    if (this.autoplay) this.start();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restart();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restart();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => {
      if (this.autoplay) this.start();
    });

    // basic swipe support
    let touchStartX = 0;
    this.root.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    this.root.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        this.goTo(this.current + (dx < 0 ? 1 : -1));
        this.restart();
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.playActiveVideo(), 150);
    });
  }

  goTo(index) {
    const total = this.slides.length;
    this.current = ((index % total) + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
    this.playActiveVideo();
  }

  playActiveVideo() {
    this.slides.forEach((slide, i) => {
      const videos = Array.from(slide.querySelectorAll('video'));
      videos.forEach((video) => {
        const visible = video.offsetParent !== null;
        if (i === this.current && visible) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (this.autoplay) this.start();
  }
}

document.querySelectorAll('.hero-carousel').forEach((el) => new HeroCarousel(el));

